<script>
import InfoTooltip from '@comp/InfoTooltip.vue'
import { scenarios } from '@src/queries.js'
import ScenarioItem from './ScenarioItem.vue'

export default {
  name: 'ScenariosPanel',
  components: {
    ScenarioItem,
    InfoTooltip,
  },
  props: {
    dataSource: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      scenarios: [],
      description: '',
    }
  },
  async mounted() {
    await this.setData()
  },
  methods: {
    async setData () {
      return this.$graphqlQuery(
        scenarios,
        { dataSourceName: this.dataSource.code },
      ).then(response => {
        this.scenarios = response.scenarios.scenarios
        this.description = response.scenarios.description
      })
    },
  },
}
</script>
<template>
  <div class="data-panel scenarios">
    <div class="data-panel-title">
      {{ $gettext('Scenarios') }}
      <InfoTooltip
        location="end"
        :max-width="600"
      >
        <!-- eslint-disable max-len -->
        <div class="tooltip-content">
          <span>{{ $gettext(description) }}</span>
        </div>
        <!-- eslint-enable max-len -->
      </InfoTooltip>
    </div>
    <div class="data-panel-content">
      <ScenarioItem
        v-for="scenario in scenarios"
        :key="scenario.name"
        :scenario="scenario"
      />
    </div>
  </div>
</template>
<style scoped>
.tooltip-content {
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  gap: 0.5rem;
}
</style>
